module.exports = "<div class=\"fy-cgv\">\n  <app-cgu></app-cgu>\n  <app-general-conditions></app-general-conditions>\n</div>"